// Font loading utility using modern FontFace API
// Ensures required fonts are loaded before chart initialization

const FONT_DEFINITIONS = [
  {
    family: 'Roboto Mono',
    weight: '400',
    style: 'normal',
    url: 'https://fonts.gstatic.com/s/robotomono/v30/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_3vq_ROW4.woff2',
    display: 'swap',
  },
  {
    family: 'Roboto Mono',
    weight: '500',
    style: 'normal',
    url: 'https://fonts.gstatic.com/s/robotomono/v30/L0xuDF4xlVMF-BfR8bXMIhJHg45mwgGEFl0_7Pq_ROW4.woff2',
    display: 'swap',
  },
  {
    family: 'Graphik',
    weight: '400',
    style: 'normal',
    url: 'https://cdn.prod.website-files.com/64bfd4a79278e7a8fe5b8d39/64bfd4a79278e7a8fe5b8d44_Graphik-Regular-Web.woff',
    display: 'swap',
  },
  {
    family: 'Graphik',
    weight: '500',
    style: 'normal',
    url: 'https://cdn.prod.website-files.com/64bfd4a79278e7a8fe5b8d39/64bfd4a79278e7a8fe5b8d57_Graphik-Medium-Web.woff',
    display: 'swap',
  },
];

// Load fonts using FontFace API
async function loadFontsWithFontFaceAPI() {
  if (!window.FontFace || !document.fonts) {
    throw new Error('FontFace API not supported');
  }

  const fontPromises = FONT_DEFINITIONS.map(async (fontDef) => {
    try {
      const font = new FontFace(fontDef.family, `url(${fontDef.url})`, {
        weight: fontDef.weight,
        style: fontDef.style,
        display: fontDef.display,
      });

      await font.load();
      document.fonts.add(font);

      return font;
    } catch (error) {
      console.warn(
        `EIN Chart: Failed to load ${fontDef.family} ${fontDef.weight}:`,
        error,
      );
      throw error;
    }
  });

  return Promise.all(fontPromises);
}

// Check if fonts are loaded and ready
function checkFontsReady() {
  if (!document.fonts || !document.fonts.check) return true;

  return FONT_DEFINITIONS.every((fontDef) =>
    document.fonts.check(`${fontDef.weight} 12px "${fontDef.family}"`),
  );
}

// Wait for fonts with timeout
function waitForFontsReady(timeout = 3000) {
  return new Promise((resolve) => {
    if (checkFontsReady()) {
      resolve();
      return;
    }

    if (!document.fonts?.ready) {
      setTimeout(resolve, 100);
      return;
    }

    const timeoutId = setTimeout(() => {
      console.warn('EIN Chart: Font loading timeout, proceeding anyway');
      resolve();
    }, timeout);

    document.fonts.ready.then(() => {
      clearTimeout(timeoutId);
      resolve();
    });
  });
}

// Main font loading function
export async function loadRequiredFonts() {
  try {
    await loadFontsWithFontFaceAPI();
    await waitForFontsReady();

    return true;
  } catch (error) {
    console.warn(
      'EIN Chart: Font loading failed, proceeding anyway:',
      error.message,
    );
    return false;
  }
}

export default loadRequiredFonts;
